import {NgModule} from '@angular/core';
import {MatDialogModule} from '@angular/material/dialog';
import {EffectsModule} from '@ngrx/effects';
import {RightsApiService} from '@pages/rights/api/rights.api.service';
import {LeftPanelEffects} from '@store/left-panel/effects';
import {RightsEffects} from '@store/rights/effects';
import {DialogsService} from 'amc-common-components';
import {RouterEffects} from './route/effects';
import {CtsDistributionApiService} from '@api/cts-distribution/cts-distribution.api.service';
import {CtsDistributionEffects} from '@store/cts-distribution/effects';

@NgModule({
	imports: [
		EffectsModule.forRoot([RouterEffects, LeftPanelEffects, RightsEffects, CtsDistributionEffects]),
		MatDialogModule,
	],
	providers: [DialogsService, RightsApiService, CtsDistributionApiService],
})
export class StoreEffectsModule {}
